import { render } from "./_picture.vue?vue&type=template&id=5ed6a752"
import script from "./_picture.vue?vue&type=script&lang=js"
export * from "./_picture.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__